import { AccountConfigService } from './../../services/account-config/account-config.service';
import { AuthService } from './../../../auth/services/auth/auth.service';
import { Component, forwardRef, Inject, OnInit, HostBinding } from '@angular/core';
import { MGridSettings, MUser } from '@argalis-apps/models';
import { FactureService } from '../../services/facture/facture.service';
import { DocumentService } from '../../services/document/document.service';
import config from './facture-list.config';

@Component({
  selector: 'ags-facture-list',
  templateUrl: './facture-list.component.html',
  styleUrls: ['./facture-list.component.scss']
})
export class FactureListComponent implements OnInit {
  @HostBinding('class') themeFlag: string;
  private userConnected: MUser.CUser = null;
  public factureList: any[] = [];
  public gridSettings: MGridSettings.IGridSettings = config;
  public kendogridlistColumnsname: any[] = [
    {
      field: 'statut',
      title: 'Statut'
    },
    {
      field: 'numero',
      title: 'Numéro de facture'
    },
    {
      field: 'dateFacturation',
      title: 'Date de facturation'
    },
    {
      field: 'datePaiement',
      title: 'Échéance'
    },
    {
      field: 'restantDu',
      title: 'Solde restant dû (€)'
    },
    {
      field: 'docGenerated',
      title: ''
    }
  ];

  constructor(
    @Inject(forwardRef(() => AuthService)) private authService: AuthService,
    private factureService: FactureService,
    public documentService: DocumentService,
    private accountConfigService: AccountConfigService
  ) {
    this.userConnected = this.authService.userConnected;
    this.authService.userChange.subscribe((user: MUser.CUser) => {
      if (user && !user.login) this.userConnected = null;
      else this.userConnected = Object.assign({}, user);
    });
  }

  ngOnInit() {
    this.getFactures();
    this.themeFlag = `${this.themeFlag || ''} ${this.accountConfigService.themingClassName}`;
  }

  getFactures() {
    let idClient: number;
    if (this.userConnected) {
      idClient = Number(this.userConnected.company.id || 0);
    }
    this.factureService.getListByIdClient(idClient).subscribe(
      (list: any[]) => {
        if (list) {
          this.factureList = list;
        }
      },
      () => {
        this.factureList = [];
      }
    );
  }
}
